var $132d1b97de231314$exports = {};
$132d1b97de231314$exports = {
    "invalidSelection": (args, formatter)=>`A kijel\xf6lt ${formatter.plural(args.selectedCount, {
            one: `d\xe1tum nem \xe9rhet\u{151} el`,
            other: `d\xe1tumok nem \xe9rhet\u{151}ek el`
        })}.`
};


export {$132d1b97de231314$exports as default};
//# sourceMappingURL=hu-HU.module.js.map
